import React from 'react'
import PropTypes from 'prop-types'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
// @material-ui/icons

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'

import dashboardStyle from 'assets/jss/material-dashboard-pro-react/views/dashboardStyle'

// Apollo thingy
import { graphql, Query } from 'react-apollo'

// Replace the following 3 lines for different component
import { getUserGroups } from '../../queries/getUserGroupsQuery'

import UserGroupTable from './UserGroupTable'
import UserGroupDetail from './UserGroupDetail'

/** 
Explaination of logic: 

1. apollo query is bound to this component, upon starting, the component retrieves data and pass it to the child of Table
   along with the data inject by qpl, there are 2 parameters pass into Table
   1) showEditProfile - handle the click on table
   2) getRefetchFunction - use to hold the 'refetch' function of qpl Query, so we can update Table view once the detail is updated
2. when a row in table is clicked, state.showDetail will be set to true which display the detail panel, and meantime the data is
   brought back from Table view as well and populate to this.state for updating
  
3. once the modified data is successfully saved, kill the detail panel and forceupdate table view as well
*/

const BuildTableView = props => {
  const { getRefetchFunction, ...rest } = props
  //fetchPolicy="network-only"
  return (
    <Query query={getUserGroups} errorPolicy="all" fetchPolicy="network-only">
      {apollocData => {
        const { loading, error, data, refetch } = apollocData
        getRefetchFunction(refetch)
        if (error) return <p>error</p>
        if (loading) {
          return <p>Loading...</p>
        } else {
          return <UserGroupTable userGroups={data.userGroups} {...rest} refetch={refetch} />
        }
      }}
    </Query>
  )
}
class UserGroupTableAndDetails extends React.Component {
  constructor(props) {
    super(props)

    this.showEditProfile = this.showEditProfile.bind(this)
    this.hideEditProfile = this.hideEditProfile.bind(this)
    this.getRefetchFunction = this.getRefetchFunction.bind(this)
  }
  state = {
    showDetail: false
  }

  getRefetchFunction(func) {
    this.forceUpdate = func
  }
  async showEditProfile(detailData) {
    // force to remount the detail component
    await this.setState({ data: detailData, showDetail: false })
    await this.setState({ data: detailData, showDetail: true })
  }

  hideEditProfile() {
    this.setState({ data: {}, showDetail: false })
  }

  render() {
    return (
      <div>
        <GridContainer>
          <GridItem xs={12}>
            <BuildTableView showEditProfile={this.showEditProfile} hideEditProfile={this.hideEditProfile} getRefetchFunction={this.getRefetchFunction} />
          </GridItem>
        </GridContainer>
        {this.state.showDetail ? (
          <GridContainer>
            <GridItem xs={12}>
              <UserGroupDetail data={this.state.data} hideEditProfile={this.hideEditProfile} refetch={this.forceUpdate} />
            </GridItem>
          </GridContainer>
        ) : (
          ''
        )}
      </div>
    )
  }
}

UserGroupTableAndDetails.propTypes = {
  classes: PropTypes.object.isRequired
}

export default graphql(getUserGroups)(withStyles(dashboardStyle)(UserGroupTableAndDetails))
